import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, Event, NavigationStart, NavigationError } from '@angular/router';
import { WidgetService } from '../../services/widget.service';
import { AppStateService } from '../../services/app-state.service';
import { WIDGET_ID } from '../../utils/constant';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  heading = '';
  // setpGeading='';
  // allHeading='';
  scrollPoniter = false;
  scrollPoniterSteps = false;
  scroll = false;
  priavcy = false;
  activeCat = '';
  categoryData = {};
  finalAssesment = false;


  constructor(private router: Router, private widgetService: WidgetService, private appStateService: AppStateService) {
    this.appStateService.getActiveCategory().subscribe(val => {
      this.activeCat = val;
    });
    this.appStateService.getCategoriesData().subscribe(val => {
      this.categoryData = val;
    });
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        console.log(event);
        if (event.url.indexOf('/pages/result') > -1) {
          this.scrollPoniter = true;
          this.scroll = false;
          this.scrollPoniterSteps = false;
          this.priavcy = false;
          this.finalAssesment = false;
        }
        if (event.url.indexOf('/pages/quiz/') > -1) {
          this.scrollPoniterSteps = true;
          this.scroll = false;
          this.scrollPoniter = false;
          this.finalAssesment = false;
          this.priavcy = false;
        }
        if (event.url == '/pages/pre-steps') {
          this.scroll = true;
          this.scrollPoniterSteps = false;
          this.scrollPoniter = false;
          this.priavcy = false;
          this.finalAssesment = false;
        }
        if (event.url == '/pages/pre-form') {
          this.scroll = true;
          this.scrollPoniterSteps = false;
          this.scrollPoniter = false;
          this.priavcy = false;
          this.finalAssesment = false;
        }
        if (event.url == '/pages/privacy-policy') {
          this.scroll = false;
          this.scrollPoniterSteps = false;
          this.scrollPoniter = false;
          this.priavcy = true;
          this.finalAssesment = false;
        }


        if (event.url == '/schedule-call') {
          this.scroll = false;
          this.scrollPoniterSteps = false;
          this.scrollPoniter = false;
          this.priavcy = false;
          this.finalAssesment = true;
        }


      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });
  }

  ngOnInit(): void {
    this.getWidget();
  }

  getWidget() {
    this.widgetService.get(WIDGET_ID).subscribe(res => {
      const categoryList = [];
      const categoriesData = {};
      if (res && res.data) {
        for (let category of res.data.widget.questionnaire.questionGroups) {
          const slug = this.convertToSlug(category.name)
          categoryList.push(slug);
          categoriesData[slug] = category;
        }
        if (res.data.accessToken) {
          localStorage.setItem('awc_code', res.data.accessToken);
        }
        this.appStateService.setCategoryList(categoryList);
        this.appStateService.setCategoriesData(categoriesData);
      }
    }, err => {
      console.log(err);
    });

  }

  convertToSlug(text: string) {
    return text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
  }
}
